<script setup lang="ts">
import { onMounted } from 'vue'
import AppShell from '@/components/layout/AppShell.vue'
import AppToasts from '@/components/ui/AppToasts.vue'
import { useRefundQueueStore } from '@/stores/refunds'
import { useApplicationQueueStore } from '@/stores/segmentApplications'
import { useSessionStore } from '@/stores/session'

const session = useSessionStore()
const refundQueue = useRefundQueueStore()
const applicationQueue = useApplicationQueueStore()

onMounted(() => {
  // Only poll the approval queue for someone who can act on it.
  if (session.can('REFUND_APPROVE')) {
    refundQueue.startPolling()
  }
  if (session.can('SEGMENT_APPLICATION_REVIEW')) {
    applicationQueue.startPolling()
  }
})
</script>

<template>
  <AppShell>
    <RouterView v-slot="{ Component, route }">
      <component :is="Component" :key="route.fullPath" />
    </RouterView>
  </AppShell>
  <AppToasts />
</template>
